var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastodoninline = function SvgMastodoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mastodon_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.077 29.765c3.215-.388 6.015-2.39 6.367-4.218.554-2.88.509-7.03.509-7.03 0-5.624-3.648-7.272-3.648-7.272-1.839-.853-4.997-1.212-8.277-1.24h-.081c-3.281.028-6.437.387-8.276 1.24 0 0-3.648 1.648-3.648 7.272l-.003 1.075c-.005 1.036-.011 2.186.019 3.386.132 5.5.998 10.92 6.031 12.265 2.321.62 4.314.75 5.919.662 2.91-.163 4.544-1.05 4.544-1.05l-.096-2.133s-2.08.663-4.416.582c-2.314-.08-4.756-.252-5.13-3.122a6 6 0 0 1-.053-.805s2.272.561 5.15.694c1.761.082 3.412-.104 5.089-.306m2.573-4.002v-6.81q0-2.087-1.056-3.315c-.726-.819-1.678-1.238-2.859-1.238-1.366 0-2.401.53-3.086 1.592l-.665 1.127-.665-1.127c-.684-1.061-1.72-1.592-3.086-1.592-1.181 0-2.133.42-2.86 1.238q-1.056 1.228-1.055 3.315v6.81h2.67v-6.61c0-1.393.581-2.1 1.742-2.1 1.283 0 1.927.839 1.927 2.498v3.618h2.655V19.55c0-1.66.643-2.498 1.926-2.498 1.16 0 1.741.707 1.741 2.1v6.61h2.67Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mastodon_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 10h24v26H11z"
  })))));
};
export default SvgMastodoninline;